import React from "react";

export default function Input(props) {
  const { label, ...other } = props;
  return (
    <div className="form-group">
      <label htmlFor="name">{label}</label>
      <input type="text" {...other} className="input" />
    </div>
  );
}
